<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>

  <form class="form" [formGroup]="affiliationTypeEditForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"></span>
      </kt-alert>

      <kt-alert
        *ngIf="hasSubmissionErrors && !hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <ul>
          <li *ngFor="let msg of submissionErrorObj">{{ msg.details | translate }}</li>
        </ul>
      </kt-alert>

      <div class="form-group row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'AFFILIATION.INPUT.AFFILIATION_TYPE_NAME' | translate }}</mat-label>
            <input matInput formControlName="affiliation_type_name" required />
            <mat-error *ngIf="isControlHasError('affiliation_type_name', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{
              'AFFILIATION.INPUT.AFFILIATION_TYPE_DESCRIPTION' | translate
            }}</mat-label>
            <textarea matInput formControlName="affiliation_type_description" required></textarea>
            <mat-error *ngIf="isControlHasError('affiliation_type_description', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            [mat-dialog-close]="data.animal"
            cdkFocusInitial
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
